import { MentionModificationsModel } from '../../../api/mentions/model/mention-modifications.model';
import { MonitoringBulkActionTypeEnum } from '../enums/monitoring-bulk-action-type.enum';
import { MonitoringFileTypesEnum } from '../enums/monitoring-file-types.enum';

export class BulkMentionActionModel {
    public currentActionType: MonitoringBulkActionTypeEnum;

    public addFolder: number;
    public addFolders: number[];
    public addTag: number;
    public addTags: number[];
    public removeFolder: number;
    public removeFolders: number[];
    public removeTag: number;
    public setSentiment: number;
    public renormalize: boolean;
    public preserveEdit: boolean;
    public removeSentiment: boolean;
    public targetAccountId: number;
    public targetFolderId: number;
    public mentionIds: number[];
    public removeFile: MonitoringFileTypesEnum;
    public taggingSavedSearchIds: number[];

    constructor(apiModel?: MentionModificationsModel) {
        if (apiModel) {
            this.addFolder = apiModel.addFolder;
            this.addFolders = apiModel.addFolders;
            this.addTag = apiModel.addTag;
            this.addTags = apiModel.addTags;
            this.removeFolder = apiModel.removeFolder;
            this.removeFolders = apiModel.removeFolders;
            this.removeTag = apiModel.removeTag;
            this.setSentiment = apiModel.setSentiment;
            this.renormalize = apiModel.renormalize;
            this.removeSentiment = apiModel.removeSentiment;
            this.targetAccountId = apiModel.targetAccountId;
            this.targetFolderId = apiModel.targetFolderId;
            this.mentionIds = apiModel.mentionIds;
            this.removeFile = apiModel.removeFile;
            this.taggingSavedSearchIds = apiModel.taggingSavedSearchIds;
        }
    }

    /**
     * Returns api model
     */
    toApi(): MentionModificationsModel {
        const apiModel: MentionModificationsModel = {};

        // cannot send any null values
        if (this.addFolder) {
            apiModel.addFolder = this.addFolder;
        }
        if (this.addFolders) {
            apiModel.addFolders = this.addFolders;
        }
        if (this.addTag) {
            apiModel.addTag = this.addTag;
        }
        if (this.addTags) {
            apiModel.addTags = this.addTags;
        }
        if (this.removeFolder) {
            apiModel.removeFolder = this.removeFolder;
        }
        if (this.removeFolders) {
            apiModel.removeFolders = this.removeFolders;
        }
        if (this.removeTag) {
            apiModel.removeTag = this.removeTag;
        }
        if (!isNaN(this.setSentiment)) {
            // setting sentiment to null will override mention sentiment value
            apiModel.setSentiment = this.setSentiment;
        }
        if (this.renormalize) {
            apiModel.renormalize = this.renormalize;
        }
        if (this.removeSentiment) {
            apiModel.removeSentiment = this.removeSentiment;
        }
        if (this.targetAccountId) {
            apiModel.targetAccountId = this.targetAccountId;
        }
        if (this.targetFolderId) {
            apiModel.targetFolderId = this.targetFolderId;
        }
        if (this.mentionIds) {
            apiModel.mentionIds = this.mentionIds;
        }
        if (this.removeFile) {
            apiModel.removeFile = this.removeFile;
        }
        if (this.taggingSavedSearchIds) {
            apiModel.taggingSavedSearchIds = this.taggingSavedSearchIds;
        }
        return apiModel;
    }

    /**
     * Sets the current action
     */
    setCurrentAction(action: MonitoringBulkActionTypeEnum) {
        this.clearModificationProperties();
        this.currentActionType = action;
    }

    /**
     * Updates appropriate property based on action state
     */
    setPropertyForCurrentAction(id: number) {
        this.clearModificationProperties();
        switch (this.currentActionType) {
            case MonitoringBulkActionTypeEnum.removeTags:
                this.removeTag = id;
                break;
            case MonitoringBulkActionTypeEnum.addTags:
                this.addTag = id;
                break;
        }
    }

    /**
     * Clears the action properties
     */
    clearModificationProperties() {
        this.addFolder = null;
        this.addFolders = [];
        this.addTag = null;
        this.removeFolder = null;
        this.removeFolders = [];
        this.removeTag = null;
        // setting sentiment to null will override mention sentiment value
        this.setSentiment = undefined;
        this.removeSentiment = null;
        this.removeFile = null;
        this.taggingSavedSearchIds = [];
    }
}
